module.exports = __webpack_public_path__ + "static/media/marijuan.app.140190ad.png";